import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const SingleUserCheckmarkCircleIcon = createIcon({
  displayName: 'SingleUserCheckmarkCircleIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M0,0H24V24H0Z" fill="none" />
      <path
        d="M17.79894,5.062,19,6.262l1.99893-2"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle cx="12" cy="9.5" r="2.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path
        d="M7.5,16a2.49821,2.49821,0,0,1,2.28894-1.5h4.42212A2.49821,2.49821,0,0,1,16.5,16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20.582,9.353A8.839,8.839,0,0,1,21,12a9,9,0,1,1-9-9,8.839,8.839,0,0,1,2.647.418"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const SingleUserCheckmarkCircle: FC<IconProps> = (props) => {
  return <CustomIcon as={SingleUserCheckmarkCircleIcon} {...props} />
}

export default memo(SingleUserCheckmarkCircle)
